import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { Props } from "./types";
import styles from "./styles.scss";
import { EnglishIcon } from "./englishIcon";
import { FrenchIcon } from "./frenchIcon";

function LanguageSelection(props: Props) {
  const { t } = useTranslation();
  const languages: string[] = t("preferences.languageSelectionForm.languages");

  return (
    <div className={styles.languageSelection}>
      {languages.map((language) => (
        <div
          key={language}
          className={classNames(styles.group, {
            [styles.selectedInput]: props.selectedLanguage === language,
          })}
          onClick={() =>
            props.selectedLanguage !== language && props.editLanguage(language)
          }
        >
          {language === "fr" ? (
            <FrenchIcon className={styles.language} />
          ) : (
            <EnglishIcon className={styles.language} />
          )}
          <label className={classNames(styles.input)}>{language}</label>
        </div>
      ))}
    </div>
  );
}

export { LanguageSelection };
